module.exports = __webpack_public_path__ + "img/norway.53a68e20.png";